export const mediaToAudioBlock = (mediaItem) => {
  const {
    name,
    description,
    mimetype,
    downloadURL,
    url: streamURL,
    thumb
  } = mediaItem

  const audio = {
    name,
    description,
    type: mimetype,
    downloadURL,
    streamURL,
    coverImage: (thumb && thumb.original) || "",
    allowDownload: false
  }

  return audio
}

// The two functions below are tested in blocks/Submit/utils
export const convertDescriptionToFeedback = (description) => {
  return description !== null
    ? { feedback: [{ html: description, showCondition: "ALWAYS" }] }
    : {}
}
export const convertFeedbackToDescription = (feedback) => {
  return feedback === null ? feedback : feedback[0].html
}
